




























import Vue from 'vue'
export default Vue.extend({
  name: 'encounter-group',
  data: () => ({
    groups: [
      { name: 'None', val: null, icon: 'mdi-close' },
      { name: 'Campaign', val: 'Campaign', icon: 'mdi-map' },
    ],
  }),
})
